<template>
	<div class="m_container" :class="openType != 'mob' ? 'flex_center flex_items vh100' : ''">
		<div class="content plr20 bgfff" style="box-sizing: border-box;" 
		:class="openType != 'mob' ? 'container_w_h' : ''" :style="openType != 'mob' ? '' : 'min-height:100vh'">
			<div class="pt20">
				<div class="page_title mb10">签到表列表</div>
			</div>
			<div class="bor_b pb20 flex_between list-content pt20 "
			v-for="(item, index) in list" :key="index"
			@click="$router.push({path:'/msetSign',query:{id:id,signId:item.id}})">
				{{item.month}}
			</div>
			<div class="empty" v-if="list.length == 0">
				暂无数据
			</div>
			<div class="bottom_btn">
				<div class="btn_contenbt" @click="$router.push({path:'/msetSign',query:{id:id}})">新建签到表</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		List
	} from "vant";
	import {openType} from '@/utils/tool.js'
	export default {
		components: {
			List
		},
		data() {
			return {
				list: [],
				page: 1,
				listH: 0,
				openType:openType(),
				id:''
			}
		},
		methods: {
			getList() {
				this.api.planList({},this.id).then(res => {
					this.list = res.data
				})
			},
		},
		created() {
			this.openType = openType()
			this.id = this.$route.query.id;
			this.getList()
		}
	}
</script>

<style scoped="scoped">
.content{
	padding-bottom: 90px;
	/* height: 100vh; */
	overflow-y: auto;
}

</style>
